"use client";

import { motion } from "framer-motion";
import { PortalCtaButton } from "@/components/landing/portal-cta-button";
import { PopText } from "@/components/motion/reveal";
import { GateGlyph } from "@/components/brand/gate-glyph";
import { GradientText } from "@/components/ui/gradient-text";
import { Spotlight } from "@/components/ui/spotlight";
import { useMotionPreference } from "@/hooks/use-motion-preference";

export function FinalCta() {
  const { reducedMotion } = useMotionPreference();
  return (
    <section className="relative overflow-hidden px-4 py-24 sm:py-28">
      <Spotlight
        fill="rgba(168,85,247,0.24)"
        size={70}
        className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      />
      <div className="relative mx-auto flex max-w-2xl flex-col items-center text-center">
        <div className="relative mb-8 grid place-items-center">
          {!reducedMotion &&
            [0, 1].map((i) => (
              <motion.span
                key={i}
                className="absolute rounded-full border border-primary/30"
                style={{ width: `${6 + i * 4}rem`, height: `${6 + i * 4}rem` }}
                animate={{ scale: [1, 1.5], opacity: [0.5, 0] }}
                transition={{ duration: 2.6, repeat: Infinity, delay: i * 0.7, ease: "easeOut" }}
              />
            ))}
          <div className="relative grid size-20 place-items-center rounded-full border border-primary/40 bg-card/70 shadow-glow backdrop-blur-sm">
            <GateGlyph size={24} className="text-primary" />
          </div>
        </div>

        <h2 className="text-balance text-5xl font-semibold tracking-tight sm:text-6xl">
          <PopText className="block">Step through</PopText>
          <PopText className="block" delay={0.18}>
            <GradientText shimmer>the gate.</GradientText>
          </PopText>
        </h2>

        <p className="mt-5 hidden max-w-lg text-lg text-muted-foreground md:block">
          Every market — crypto, tokenized stocks, prediction markets, baskets — across every
          chain, from one wallet, one tap.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <PortalCtaButton />
        </div>
      </div>
    </section>
  );
}
